export default {
  obraRHID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  responsavelID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  secaoRH: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  secaoRHID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  situacao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  localTrabalho: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  localTrabalhoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataInicioSolicitacao: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  dataFimSolicitacao: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  clienteRHID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  colaborador: {
    value: null,
    condernador: null,
    funcao: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/employeeboard/search/search-form.js